import {Node, mergeAttributes} from '@tiptap/core'

export type HtmlEmbedOptions = {
  HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    htmlEmbed: {
      setHtmlEmbed: (options: {html: string}) => ReturnType
    }
  }
}

const HtmlEmbed = Node.create<HtmlEmbedOptions>({
  name: 'htmlEmbed',

  group: 'block',

  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      html: {
        default: '',
        rendered: false,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div.raw-html-embed',
        getAttrs: (node) => {
          const element = node as HTMLElement
          return {html: element.innerHTML}
        },
      },
    ]
  },

  renderHTML() {
    return [
      'div',
      mergeAttributes(this.options.HTMLAttributes, {
        class: 'raw-html-embed',
      }),
    ]
  },

  addNodeView() {
    return ({node, getPos, editor}) => {
      const dom = document.createElement('div')
      dom.classList.add('raw-html-embed')

      const label = document.createElement('div')
      label.className = 'raw-html-embed__label'
      label.textContent = 'HTML snippet'
      dom.appendChild(label)

      const textarea = document.createElement('textarea')
      textarea.className = 'raw-html-embed__code'
      textarea.value = node.attrs.html || ''
      textarea.spellcheck = false
      dom.appendChild(textarea)

      textarea.addEventListener('input', () => {
        if (typeof getPos === 'function') {
          editor.view.dispatch(
            editor.view.state.tr.setNodeMarkup(getPos(), undefined, {
              html: textarea.value,
            }),
          )
        }
      })

      return {
        dom,
        stopEvent: (event: Event) => {
          return dom.contains(event.target as globalThis.Node)
        },
        ignoreMutation: () => true,
        update: (updatedNode) => {
          if (updatedNode.type.name !== 'htmlEmbed') {
            return false
          }
          if (textarea.value !== updatedNode.attrs.html) {
            textarea.value = updatedNode.attrs.html || ''
          }
          return true
        },
      }
    }
  },

  addCommands() {
    return {
      setHtmlEmbed: (options) => ({commands}) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        })
      },
    }
  },
})

export default HtmlEmbed
